import { render, staticRenderFns } from "./InvoiceContract.vue?vue&type=template&id=4e8a2f38"
import script from "./InvoiceContract.vue?vue&type=script&lang=js"
export * from "./InvoiceContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports